import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { PartnersCreateView } from './create/create';
import { PartnersDetailView } from './detail/detail';
import { PartnersListView } from './list/list';
import { PartnersOrdersView } from './orders/orders';

export const PartnersView = angular
  .module('acme.view.application.partners', [
    uiRouter,
    'ui.bootstrap',
    'acme.view.application.partners.controllers',
    PartnersListView,
    PartnersCreateView,
    PartnersDetailView,
    PartnersOrdersView,
    'acme.common.directive.dataGrid',
    'acme.view.application.dataGrid.controllers',
  ])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.partners',
      url: '/organizations',
      abstract: true,
      views: {
        'subview-main': {
          templateUrl: 'views/application/views/partners/partners.tpl.html',
        },
      },
      data: {
        pageTitle: 'Organizations',
        permissions: ['ACCT_VIEW'],
      },
    });
  }).name;
